import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {
  constructor(
    private datePipe: DatePipe,
  ) {}

  public download(data: any, fileName: string): void {
    const header: string[][] = [[]];
    const workSheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();

    const modifiedData = data.map((row: any) => {
      for (const key in row) {
        if (row[key] && this.isValidUrl(row[key])) {
          row[key] = {
            f: `HYPERLINK("${row[key]}", "${row[key]}")`,
          };
        }
      }
      return row;
    });

    XLSX.utils.sheet_add_aoa(workSheet, header);
    XLSX.utils.sheet_add_json(workSheet, modifiedData, { origin: 'A2', skipHeader: true });
    XLSX.utils.book_append_sheet(workBook, workSheet, 'Sheet1');

    XLSX.writeFile(workBook, `${fileName} - ${this.getFilenamePostfix()}.xlsx`);
  }

  private getFilenamePostfix(): string {
    return this.datePipe.transform(new Date(), 'dd_MM_yyyy_HH_mm_ss');
  }

  private isValidUrl(value: string): boolean {
    const pattern = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
    return pattern.test(value);
  }
}
